import React, { useContext } from "react";
import { AuthContext } from "../../Auth/useAuth";
import ItemService from "../../components/ItemService";
import MarcasSlider from "../../components/MarcaSlider/Index";
import Slider from "../../components/Slider";
import "./Home.css";
import PreServicios from "../../components/PreServicios/Index";
import ProductCategories from "../../components/ProductCategories";
import ContactForm from "../../components/ContactForm";
const imgOptimizador = "https://cdn.nudus.app/Images/Optimizador.png";
const imgTienda = "https://cdn.nudus.app/Images/tienda.png";
const imgService1 = "https://cdn.nudus.app/Images/services/construccion-en-seco.jpg";
const imgService2 = "https://cdn.nudus.app/Images/services/yeso.jpg";
const imgService3 = "https://cdn.nudus.app/Images/services/placas.jpg";
const imgService4 = "https://cdn.nudus.app/Images/services/techos.png";
const imgService5 = "https://cdn.nudus.app/Images/services/rurales.png";
const imgService6 = "https://cdn.nudus.app/Images/services/tromen.jpg";
const imgService7 = "https://cdn.nudus.app/Images/services/perfiles.jpg";
const imgService8 = "https://cdn.nudus.app/Images/services/herramientas.jpg";
const imgService9 = "https://cdn.nudus.app/Images/services/mucho-mas.png";

const Home = () => {
  const { login, logout } = useContext(AuthContext);
  let dateLogin = localStorage.getItem("date");
  if (dateLogin !== null && Date.now() - parseInt(dateLogin) < 172800000) {
    login();
    localStorage.setItem("date", Date.now());
  } else {
    logout();
    localStorage.removeItem("date");
  }

  return (
    <>
      <Slider showTitles={true} />

      <div className="experience-container">
        <div className="home-tittles">
          <h3>La experiencia nos respalda</h3>
          <hr />
        </div>
        <div className="flex-wrap-row">
          <div className="experience-text div-50">
            <h4>Más de 30 años de experiencia...</h4>
            <p>
              <strong style={{ fontWeight: '900' }}>Lumadi Maderas</strong> es una empresa familiar con más de tres décadas de trayectoria, nacida con el objetivo de abastecer al carpintero y al hombre de campo. Con el paso del tiempo, crecimos sostenidamente, ampliando nuestra oferta de productos para acompañar las nuevas demandas del sector.
              <br />
              <br />
              Hoy contamos con un amplio catálogo que incluye <strong>steel frame, chapas policarbonato acanalada, pisos flotantes, perfiles WPC, melaminas, placas PVC, herrajes, herramientas, techos,</strong> entre muchos otros materiales para la construcción.
              <br />
              <br />
              Gracias a nuestro compromiso, seriedad y dedicación, hemos construido relaciones sólidas con clientes y proveedores, lo que nos ha permitido representar a <strong>marcas líderes del mercado.</strong>
              <br />
              <br />
              Nuestro alcance comercial traspasa las fronteras geográficas, pero seguimos conservando la <strong>calidez, solidez y confianza</strong> que nos caracterizan desde los inicios. Nos esforzamos para que cada experiencia de compra sea eficiente, cercana y 100% satisfactoria.
            </p>
          </div>

          <div className="video-yt div-50">
            <div className="border-video">
              <iframe
                src="https://www.youtube.com/embed/wLBLMfo5FhM"
                title="LUMADI Maderas S.A. - Video Comercial"
                autoPlay
                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <div style={{ }} className="experience-container">
        <ProductCategories />
      </div>

      <div className="experience-container">
        <div className="home-tittles">
          <h3>Contactanos</h3>
          <hr />
        </div>
        <ContactForm />
      </div>

      <MarcasSlider />

      <div className="optimizador-container">
        <div className="home-tittles">
          <h3>Optimizamos los trabajos</h3>
          <hr />
        </div>

        <div className="optimizador-image-container">
          <div className="div-50">
            <div className="div-center">
              <img
                className="optimizador-image"
                loading="lazy"
                src={imgOptimizador}
                alt="optimizadorImage"
              />
            </div>
          </div>
          <div className="experience-text div-50">
            <h4>Tenemos un optimizador online</h4>
            <p>
              Podes enviarnos tus cortes a través de nuestro optimizador online,
              rellenando el formulario con unos pocos clicks, hacemos los
              recortes, pegamos los cantos y nos comunicamos cuando estén listos
              para coordinar la entrega. Hacemos tus compras y trabajos mucho
              más fácil.
            </p>
            <a
              href="https://optimizadorlumadi.com.ar/"
              target="_blank"
              rel="noreferrer"
            >
              <span className="go-to-opt">Probar optimizador</span>
            </a>
          </div>
        </div>
      </div>

      <div className="tienda-container">
        <div className="home-tittles">
          <h3>Comprá desde tu casa</h3>
          <hr />
        </div>
        <div className="tienda-image-container">
          <div className="experience-text div-50">
            <h4>Podes usar nuestro e-commerce</h4>
            <p>
              Tenemos una tienda online con los precios más competitivos.
              <br />A través de una web muy accesible en la que con un par de
              clicks podés comprar las herramientas y materiales que te gusten y
              necesites, teniendo las mejores opciones de envíos y métodos de
              pago para hacer tus compras de la manera más cómoda posible.
            </p>
            <a href="https://tienda.lumadimaderas.com.ar">
              <span className="go-to-shop">Ir a la tienda online</span>
            </a>
          </div>
          <div className="div-50 image-tienda">
            <div className="div-center">
              <img loading="lazy" src={imgTienda} alt="tiendaImage" />
            </div>
          </div>
        </div>
      </div>

      <PreServicios />

      <div className="service-container">
        <div className="home-tittles">
          <h3>Lo que hacemos por vos</h3>
          <hr />
        </div>
        <div className="Items-service-container">
          <ItemService
            img={imgService1}
            text="Somos proveedores del sistema que está marcando un cambio en los tiempos y costos de obra"
            title="Construcción en seco"
          />
          <ItemService
            img={imgService2}
            text="Somos proveedores del sistema que está marcando un cambio en los tiempos y costos de obra"
            title="Yeso Proyectado"
          />
          <ItemService
            img={imgService3}
            text="FAPLAC confía en nosotros para que distribuyamos exclusivamente toda su linea de los mejores aglomerados y tableros de MDF"
            title="Placas"
          />
          <ItemService
            img={imgService4}
            text="Brindamos todos los materiales para que construyas tus techos de madera, teniendo todos los beneficios que estos ofrecen"
            title="Techos"
          />
          <ItemService
            img={imgService5}
            text="Acompañams a los productores ganaderos y agropecuarios satisfaciendo sus necesidades con un amplio stock, postes, varillas, tanques, bretes, comederos, etc."
            title="Articulos rurales"
          />
          <ItemService
            img={imgService6}
            text="Distribuimos exclusivamente toda la linea TROMEN, que con su sistema de doble combustión, optimiza la calefacción"
            title="Calefacción, hornos y parrillas"
          />
          <ItemService
            img={imgService7}
            text="Amplia variedad de colores y medidas."
            title="Chapas y perfiles"
          />
          <ItemService
            img={imgService8}
            text="Distribuidores de DeWALT, STANLEY, BLACK AND DECKER, IRWIN, LENOX y KREG, MONTANA, PONY, VIRUTEX"
            title="Herramientas"
          />
          <ItemService
            img={imgService9}
            text="Ofrecemos pegado de cantos, cortes personalizados, variedad increíble de maderas con stock permanente, etc."
            title="Muchas cosas más"
          />
        </div>
      </div>
    </>
  );
};

export default Home;
